import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { CommunityRunning } from 'images/latest'

const CommunityRunningIcon = ({ color = 'black' }) => (
  <ResponsiveSVG
    width='42px'
    height='33px'
    className='unstyled'
    fill={color}
    SVG={CommunityRunning}
  />
)

export default CommunityRunningIcon
